import React from 'react'
import TheContent from './TheContent'
import TheHeader from './TheHeader'
import './container-front.css'

const TheLayout = () => {
  return (
    <div className="front-app" style={{ minHeight: 0 }}>
      <div className="front-wrapper" style={{ minHeight: 0, marginBottom: '50px' }}>
        <TheHeader />
        <div className="c-body">
          <TheContent />
        </div>
      </div>
    </div>
  )
}

export default TheLayout
